import ServiceDeskMyCityForm from './component'

export default ServiceDeskMyCityForm
